import { create } from 'zustand'
import { ExternalPaywallUrlParams } from '../../../types'

interface Store {
  modalGetApp: {
    show: boolean
    onOpen(): void
    onDismiss(): void
  }
  modalShortcutsMenu: {
    show: boolean
    onOpen(): void
    onDismiss(): void
  }
  modalReferralLink: {
    show: boolean
    onOpen(): void
    onDismiss(): void
  }
  modalGroupPlanTrial: {
    show: boolean
    onOpen(): void
    onDismiss(): void
  }
  modalExternalPaywall: {
    show: boolean
    onOpen(params: ExternalPaywallUrlParams): void
    onDismiss(): void
    params?: ExternalPaywallUrlParams
  }
  closeAll(): void
}

export const useStoreModals = create<Store>((set, get) => ({
  modalGetApp: {
    show: false,
    onOpen: () =>
      set({
        modalGetApp: {
          ...get().modalGetApp,
          show: true
        }
      }),
    onDismiss: () => set({ modalGetApp: { ...get().modalGetApp, show: false } })
  },
  modalShortcutsMenu: {
    show: false,
    onOpen: () =>
      set({
        modalShortcutsMenu: {
          ...get().modalShortcutsMenu,
          show: true
        }
      }),
    onDismiss: () =>
      set({
        modalShortcutsMenu: {
          ...get().modalShortcutsMenu,
          show: false
        }
      })
  },
  modalReferralLink: {
    show: false,
    onOpen: () =>
      set({
        modalReferralLink: {
          ...get().modalReferralLink,
          show: true
        }
      }),
    onDismiss: () =>
      set({
        modalReferralLink: {
          ...get().modalReferralLink,
          show: false
        }
      })
  },
  modalGroupPlanTrial: {
    show: false,
    onOpen: () =>
      set({
        modalGroupPlanTrial: {
          ...get().modalGroupPlanTrial,
          show: true
        }
      }),
    onDismiss: () =>
      set({
        modalGroupPlanTrial: {
          ...get().modalGroupPlanTrial,
          show: false
        }
      })
  },
  modalExternalPaywall: {
    show: false,
    params: undefined,
    onOpen: (params) =>
      set({
        modalExternalPaywall: {
          ...get().modalExternalPaywall,
          show: true,
          params
        }
      }),
    onDismiss: () =>
      set({
        modalExternalPaywall: {
          ...get().modalExternalPaywall,
          show: false,
          params: undefined
        }
      })
  },
  closeAll: () =>
    set({
      modalGetApp: { ...get().modalGetApp, show: false },
      modalShortcutsMenu: { ...get().modalShortcutsMenu, show: false },
      modalGroupPlanTrial: { ...get().modalGroupPlanTrial, show: false },
      modalReferralLink: { ...get().modalReferralLink, show: false },
      modalExternalPaywall: {
        ...get().modalExternalPaywall,
        show: false,
        params: undefined
      }
    })
}))
